import { render, staticRenderFns } from "./personal-information.vue?vue&type=template&id=6ec9c4bf&"
import script from "./personal-information.vue?vue&type=script&lang=js&"
export * from "./personal-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports